import { render, staticRenderFns } from "./director-payment.vue?vue&type=template&id=1ba98f88&scoped=true&"
import script from "./director-payment.vue?vue&type=script&lang=ts&"
export * from "./director-payment.vue?vue&type=script&lang=ts&"
import style0 from "./director-payment.vue?vue&type=style&index=0&id=1ba98f88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba98f88",
  null
  
)

export default component.exports